import { DELETE_PURCHASE } from "../../types/PurchaseType";

import axios from "axios";
import { toast } from "react-toastify";

const deletePurchaseAction = (id) => {
	return {
		type: DELETE_PURCHASE,
		payload: id,
	};
};

const getApiErrorMessage = (error) => {
	const data = error?.response?.data;
	if (typeof data === "string" && data.trim()) return data;
	if (data?.error) return data.error;
	if (data?.message) return data.message;
	return error?.message || "Failed to delete purchase invoice";
};

export const deletePurchase = (id) => {
	return async (dispatch) => {
		try {
			const { data } = await axios({
				method: "post",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json;charset=UTF-8",
				},
				url: "purchase-invoice/",
				data: {
					action: "delete",
					id: Number(id),
				},
			});

			if (data?.success) {
				dispatch(deletePurchaseAction(id));
				toast.success(data.message || "Purchase invoice deleted successfully");
				return { message: "success" };
			}

			const errMsg =
				(typeof data === "string" && data) ||
				data?.error ||
				data?.message ||
				"Delete failed — server did not confirm deletion";
			toast.error(errMsg);
			return { message: "error", error: errMsg };
		} catch (error) {
			const msg = getApiErrorMessage(error);
			toast.error(msg);
			console.error("deletePurchase error:", error?.response?.data || error);
			return { message: "error", error: msg };
		}
	};
};
